import { render, staticRenderFns } from "./navbar-v2.vue?vue&type=template&id=9901ed84&scoped=true"
import script from "./navbar-v2.vue?vue&type=script&lang=js"
export * from "./navbar-v2.vue?vue&type=script&lang=js"
import style0 from "./navbar-v2.vue?vue&type=style&index=0&id=9901ed84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9901ed84",
  null
  
)

export default component.exports